import React from 'react';
import Wda_sprite from '../images/wda-sprite.svg';



const WinnersPage = () => {
  return (
    <section className="section page__wrapper emerge" data-expose="true" data-effect="slide" data-duration="500" data-up="20rem" data-initialized="1" data-style-1="transform: translate(0,20rem);transform-origin: undefined;" data-style-2="transform: translate(0,0); transition: opacity 500ms ease-out, transform 500ms cubic-bezier(0, 0.9, 0.1, 1);" style={{ opacity: 1, transform: 'translate(0,0)', transition: 'opacity 500ms ease-out, transform 500ms cubic-bezier(0, 0.9, 0.1, 1)' }}>
    <h2 className="section__title border-none">
      <svg className="section__title-icon svg-icon" aria-hidden="true">
        <use xlinkHref={`${Wda_sprite}#title-pixel-1`}></use>
      </svg>
      Победители по номинациям <span className="color-yellow font-pixel nominees__title-counter">/2019–2026</span>
    </h2>
    <ul className='cases'>
      <li className="cases__item">
        <div className="cases__item-title">Лучший маркетинговый проект года</div>
        <li>
          <div className='page-about__text'>
            
            <ul className='mg-top'>
              <li className='page-about__list-item'><span className='color-yellow font-pixel disp_contents'>2019</span> <b className='disp_contents'>Алексей Иванов (Украина)</b> — за разработку инновационного маркетингового проекта, который значительно увеличил узнаваемость бренда и способствовал росту продаж.</li>
              <li className='page-about__list-item'><span className='color-yellow font-pixel disp_contents'>2020</span> <b className='disp_contents'>Мария Соколова (Беларусь)</b> — за успешную реализацию маркетинговой стратегии, которая привлекла широкую аудиторию и повысила лояльность клиентов.</li>
              <li className='page-about__list-item'><span className='color-yellow font-pixel disp_contents'>2021</span> <b className='disp_contents'>Игорь Петров (Казахстан)</b> — за креативную кампанию, использующую нестандартные подходы для достижения значительных результатов в продажах.</li>
              <li className='page-about__list-item'><span className='color-yellow font-pixel disp_contents'>2022</span> <b className='disp_contents'>Екатерина Смирнова (Узбекистан)</b> — за комплексную стратегию, направленную на улучшение восприятия бренда и увеличение рыночной доли.</li>
              <li className='page-about__list-item'><span className='color-yellow font-pixel disp_contents'>2023</span> <b className='disp_contents'>Дмитрий Ковалев (Россия)</b> — за уникальную интеграцию традиционных и цифровых каналов, что позволило бренду добиться высокого уровня взаимодействия с аудиторией.</li>
              <li className='page-about__list-item '><span className='color-yellow font-pixel disp_contents'>2024</span> <b className='disp_contents'>Ольга Васильева (Армения)</b> — за креативную и эффективную маркетинговую кампанию, которая принесла бренду международное признание и рост продаж.</li>
                      <li className='page-about__list-item '>
            <span className='color-yellow font-pixel disp_contents'>2025</span>{' '}
            <b className='disp_contents'>Арман Саркисян (Армения)</b> — за масштабную омниканальную кампанию, которая обеспечила рост продаж и вывела бренд в лидеры категории на нескольких рынках.
          </li>
                                <li className='page-about__list-item mb-20'>
            <span className='color-yellow font-pixel disp_contents'>2026</span>{' '}
            <b className='disp_contents'>Айгерим Токтарова (Казахстан)</b> — за запуск омниканальной кампании с персонализацией по жизненным сценариям, которая обеспечила рост продаж и укрепила позиции бренда на нескольких рынках.
          </li>
            </ul>
          </div>
        </li>

      </li>

      <li className="cases__item">
    <div className="cases__item-title">Инновации в маркетинге</div>
    <li>
      <div className='page-about__text'>
        <ul className='mg-top'>
          <li className='page-about__list-item'>
            <span className='color-yellow font-pixel disp_contents'>2019</span>{' '}
            <b className='disp_contents'>Наргыз Аманбекова (Казахстан)</b> — за эффективное использование Big Data и аналитики для прогнозирования поведения потребителей и оптимизации маркетинговых бюджетов.
          </li>
          <li className='page-about__list-item'>
            <span className='color-yellow font-pixel disp_contents'>2020</span>{' '}
            <b className='disp_contents'>Дмитрий Шевцов (Беларусь)</b> — за использование дополненной реальности (AR) в проекте, что привлекло молодую аудиторию и значительно повысило вовлеченность.
          </li>
          <li className='page-about__list-item'>
            <span className='color-yellow font-pixel disp_contents'>2021</span>{' '}
            <b className='disp_contents'>Нурбек Абдурахманов (Узбекистан)</b> — за успешное внедрение машинного обучения в рекламные кампании, что увеличило эффективность кампаний в реальном времени.
          </li>
          <li className='page-about__list-item'>
            <span className='color-yellow font-pixel disp_contents'>2022</span>{' '}
            <b className='disp_contents'>Асель Бекмуратова (Казахстан)</b> — за применение блокчейн-технологий для повышения прозрачности рекламных процессов.
          </li>
          <li className='page-about__list-item'>
            <span className='color-yellow font-pixel disp_contents'>2023</span>{' '}
            <b className='disp_contents'>Оксана Полищук (Россия)</b> — за внедрение виртуальной реальности в проект, что улучшило взаимодействие с клиентами и повысило продажи.
          </li>
          <li className='page-about__list-item'>
            <span className='color-yellow font-pixel disp_contents'>2024</span>{' '}
            <b className='disp_contents'>Евгений Боровский (Беларусь)</b> — за внедрение AI-алгоритмов для персонализации маркетинговых предложений, что значительно увеличило вовлеченность потребителей.
          </li>
          <li className='page-about__list-item'>
            <span className='color-yellow font-pixel disp_contents'>2025</span>{' '}
            <b className='disp_contents'>Алина Романова (Украина)</b> — за внедрение генеративного AI и автоматизированных креативов, что ускорило производство контента и повысило эффективность кампаний.
          </li>
                                <li className='page-about__list-item mb-20'>
            <span className='color-yellow font-pixel disp_contents'>2026</span>{' '}
            <b className='disp_contents'>Лейла Рзаева (Азербайджан)</b> — за внедрение генеративного AI и автоматизированного production-контура креативов, что сократило time-to-market и повысило эффективность коммуникаций.
          </li>          
        </ul>
      </div>
    </li>
  </li>

  <li className="cases__item">
    <div className="cases__item-title">Лидер цифрового маркетинга</div>
    <li>
      <div className='page-about__text'>
        <ul className='mg-top'>
          <li className='page-about__list-item'>
            <span className='color-yellow font-pixel disp_contents'>2019</span>{' '}
            <b className='disp_contents'>Сергей Мельников (Украина)</b> — за выдающуюся кампанию в цифровом маркетинге, которая привела к росту органического трафика и конверсий.
          </li>
          <li className='page-about__list-item'>
            <span className='color-yellow font-pixel disp_contents'>2020</span>{' '}
            <b className='disp_contents'>Динара Асылова (Казахстан)</b> — за эффективное использование SEO и SMM в цифровой стратегии, что значительно увеличило аудиторию и конверсию.
          </li>
          <li className='page-about__list-item'>
            <span className='color-yellow font-pixel disp_contents'>2021</span>{' '}
            <b className='disp_contents'>Тигран Петросян (Армения)</b> — за выдающуюся работу с контекстной рекламой и социальными сетями, что принесло значительные результаты.
          </li>
          <li className='page-about__list-item'>
            <span className='color-yellow font-pixel disp_contents'>2022</span>{' '}
            <b className='disp_contents'>Никита Лебедев (Россия)</b> — за внедрение автоматизации в маркетинговые процессы, что привело к росту подписчиков и вовлеченности.
          </li>
          <li className='page-about__list-item'>
            <span className='color-yellow font-pixel disp_contents'>2023</span>{' '}
            <b className='disp_contents'>Анна Коваленко (Беларусь)</b> — за успешное использование данных и аналитики в цифровых кампаниях, что значительно увеличило взаимодействие с клиентами.
          </li>
          <li className='page-about__list-item'>
            <span className='color-yellow font-pixel disp_contents'>2024</span>{' '}
            <b className='disp_contents'>Айнур Аманова (Казахстан)</b> — за выдающуюся кампанию, объединившую большие данные и социальные медиа, что привело к значительному увеличению пользователей.
          </li>
                    <li className='page-about__list-item'>
            <span className='color-yellow font-pixel disp_contents'>2025</span>{' '}
            <b className='disp_contents'>Тимур Ахметов (Казахстан)</b> — за комплексную performance-стратегию с упором на аналитику и оптимизацию конверсий, обеспечившую существенный рост онлайн-выручки.
          </li>
                                 <li className='page-about__list-item mb-20'>
            <span className='color-yellow font-pixel disp_contents'>2026</span>{' '}
            <b className='disp_contents'>Даниил Корнеев (Россия)</b> — за выстроенную performance-стратегию с акцентом на эксперименты и оптимизацию конверсий, обеспечившую существенный рост онлайн-выручки и снижение CAC.
          </li>         
        </ul>
      </div>
    </li>
  </li>

  <li className="cases__item">
    <div className="cases__item-title">Лучшая PR-кампания</div>
    <li>
      <div className='page-about__text'>
        <ul className='mg-top'>
          <li className='page-about__list-item'>
            <span className='color-yellow font-pixel disp_contents'>2019</span>{' '}
            <b className='disp_contents'>Бакыт Толонбаев (Киргизия)</b> — за успешную PR-стратегию, которая значительно улучшила репутацию бренда на национальном уровне.
          </li>
          <li className='page-about__list-item'>
            <span className='color-yellow font-pixel disp_contents'>2020</span>{' '}
            <b className='disp_contents'>Анна Карпова (Россия)</b> — за выдающуюся кампанию, направленную на поддержку социальных инициатив во время пандемии, что вызвало позитивный отклик в СМИ.
          </li>
          <li className='page-about__list-item'>
            <span className='color-yellow font-pixel disp_contents'>2021</span>{' '}
            <b className='disp_contents'>Гаянэ Туманян (Армения)</b> — за креативную PR-кампанию, которая укрепила связи с медиа и привлекла новых клиентов.
          </li>
          <li className='page-about__list-item'>
            <span className='color-yellow font-pixel disp_contents'>2022</span>{' '}
            <b className='disp_contents'>Анна Малинина (Беларусь)</b> — за PR-стратегию, эффективно управлявшую кризисными ситуациями, что помогло сохранить позитивный имидж компании.
          </li>
          <li className='page-about__list-item'>
            <span className='color-yellow font-pixel disp_contents'>2023</span>{' '}
            <b className='disp_contents'>Мария Ермекова (Казахстан)</b> — за кампанию, которая успешно улучшила имидж компании через серию медийных мероприятий.
          </li>
          <li className='page-about__list-item'>
            <span className='color-yellow font-pixel disp_contents'>2024</span>{' '}
            <b className='disp_contents'>Нодир Кадыров (Узбекистан)</b> — за успешную PR-кампанию, которая принесла бренду международное признание.
          </li>
                    <li className='page-about__list-item'>
            <span className='color-yellow font-pixel disp_contents'>2025</span>{' '}
            <b className='disp_contents'>София Гринберг (Беларусь)</b> — за стратегию репутационного PR и работу с медиа, которая укрепила доверие к бренду и обеспечила широкий охват в ключевых СМИ.
          </li>
                                <li className='page-about__list-item mb-20'>
            <span className='color-yellow font-pixel disp_contents'>2026</span>{' '}
            <b className='disp_contents'>Марина Савицкая (Беларусь)</b> — за репутационную PR-стратегию и работу с медиа/сообществами, которая усилила доверие к бренду и дала высокий органический охват.
          </li>          
        </ul>
      </div>
    </li>
  </li>

  <li className="cases__item">
    <div className="cases__item-title">Лучшее использование данных в маркетинге</div>
    <li>
      <div className='page-about__text'>
        <ul className='mg-top'>
          <li className='page-about__list-item'>
            <span className='color-yellow font-pixel disp_contents'>2019</span>{' '}
            <b className='disp_contents'>Ирина Власенко (Украина)</b> — за выдающееся использование аналитики и данных для увеличения продаж и вовлеченности в рамках крупной рекламной кампании.
          </li>
          <li className='page-about__list-item'>
            <span className='color-yellow font-pixel disp_contents'>2020</span>{' '}
            <b className='disp_contents'>Сергей Смирнов (Беларусь)</b> — за применение data-driven подхода для повышения эффективности рекламных кампаний.
          </li>
          <li className='page-about__list-item'>
            <span className='color-yellow font-pixel disp_contents'>2021</span>{' '}
            <b className='disp_contents'>Екатерина Зайцева (Казахстан)</b> — за внедрение аналитики и машинного обучения для улучшения результатов рекламных кампаний.
          </li>
          <li className='page-about__list-item'>
            <span className='color-yellow font-pixel disp_contents'>2022</span>{' '}
            <b className='disp_contents'>Артак Григорян (Армения)</b> — за успешное использование данных для сегментации аудитории и оптимизации рекламных стратегий.
          </li>
          <li className='page-about__list-item'>
            <span className='color-yellow font-pixel disp_contents'>2023</span>{' '}
            <b className='disp_contents'>Фаррух Саидов (Узбекистан)</b> — за внедрение аналитики для улучшения взаимодействия с клиентами и повышения эффективности рекламных решений.
          </li>
          <li className='page-about__list-item'>
            <span className='color-yellow font-pixel disp_contents'>2024</span>{' '}
            <b className='disp_contents'>Азиза Шарипова (Киргизия)</b> — за выдающееся использование больших данных для повышения вовлеченности и улучшения стратегий продвижения брендов.
          </li>
                    <li className='page-about__list-item'>
            <span className='color-yellow font-pixel disp_contents'>2025</span>{' '}
            <b className='disp_contents'>Шерзод Хамидов (Узбекистан)</b> — за построение data-driven модели сегментации и персонализации, которая повысила удержание клиентов и эффективность маркетинговых инвестиций.
          </li>
                                 <li className='page-about__list-item mb-20'>
            <span className='color-yellow font-pixel disp_contents'>2026</span>{' '}
            <b className='disp_contents'>Шохрух Ниязов (Узбекистан)</b> — за построение data-driven модели сегментации и триггерной персонализации, которая повысила удержание клиентов и эффективность маркетинговых инвестиций.
          </li>         
        </ul>
      </div>
    </li>
    </li>
    </ul>

  </section>
  );
};

export default WinnersPage;
